import Claims from './claims';

export default Claims;
